import { useEffect } from "react";

const DEFAULT_DESC =
  "Practical apps, digital tools and resources designed specifically for home-educating families. Built from first-hand experience of home education.";

function setMeta(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, description = DEFAULT_DESC }) {
  useEffect(() => {
    if (title) document.title = title;
    setMeta("description", description);
  }, [title, description]);
  return null;
}
